import { ServiceResponse } from "../ServiceResponse";

export class UpdatePasswordResponse extends ServiceResponse {
}
